// Urls
import { getLtsInfoUrl } from "../../urls/mavin-tools/LtsToolURL";

//Utils
import { sendCreateOrUpdateRequest } from "../../utils/api/apiUtils";

export async function getLtsInfoFn(mediaInfoBean) {
  return sendCreateOrUpdateRequest(getLtsInfoUrl, mediaInfoBean);
}
